import { Integration, Options } from "@jupiter/types";
import { Logger } from "@jupiter/utils";
import { getCurrentHub } from "@jupiter/hub";

export interface IntegrationIndex {
  [key: string]: Integration;
}

export const installedIntegrations: string[] = [];

/** Gets integration to install */
export function getIntegrationsToSetup(options: Options): Integration[] {
  const defaultIntegrations =
    (options.defaultIntegrations && [...options.defaultIntegrations]) || [];
  const userIntegrations = options.integrations;

  let integrations: Integration[] = [];
  if (Array.isArray(userIntegrations)) {
    const userIntegrationsNames = userIntegrations.map((i) => i.name);
    const pickedIntegrationsNames: { [name: string]: boolean } = {};

    defaultIntegrations.forEach((defaultIntegration) => {
      if (
        userIntegrationsNames.indexOf(defaultIntegration.name) === -1 &&
        !(defaultIntegration.name in pickedIntegrationsNames)
      ) {
        integrations.push(defaultIntegration);
        pickedIntegrationsNames[defaultIntegration.name] = true;
      }
    });

    userIntegrations.forEach((userIntegration) => {
      if (userIntegration.name in pickedIntegrationsNames) {
        return;
      }
      integrations.push(userIntegration);
      pickedIntegrationsNames[userIntegration.name] = true;
    });
  } else {
    integrations = [...defaultIntegrations];
  }

  return integrations;
}

/** Setup given integration */
export function setupIntegration(integration: Integration): void {
  if (installedIntegrations.indexOf(integration.name) !== -1) {
    return;
  }

  integration.setupOnce(getCurrentHub);
  installedIntegrations.push(integration.name);

  Logger.log(`Integration installed: ${integration.name}`);
}

/**
 * Given a list of integration instances this installs them all. When `withDefaults` is set to `true` then all default
 * integrations are added unless they were already provided before.
 * @param integrations array of integration instances
 */
export function setupIntegrations<O extends Options>(
  options: O
): IntegrationIndex {
  const integrations: IntegrationIndex = {};

  getIntegrationsToSetup(options).forEach((integration) => {
    integrations[integration.name] = integration;
    setupIntegration(integration);
  });

  return integrations;
}
